import script from "./Desktop.vue?vue&type=script&setup=true&lang=ts"
export * from "./Desktop.vue?vue&type=script&setup=true&lang=ts"

import "./Desktop.vue?vue&type=style&index=0&id=e511c7a0&scoped=true&lang=css"
import "./Desktop.vue?vue&type=style&index=1&id=e511c7a0&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e511c7a0"]])

export default __exports__